import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { IMainState } from 'store/states'

export function useIsLastLessonHigher() {
  const order = useSelector(
    ({ lmsLessons }: IMainState) => lmsLessons.lesson?.order
  )

  const [lastOrderLesson, setLastOrderLesson] = useState<number>()

  useEffect(() => {
    if (order && (!lastOrderLesson || order >= lastOrderLesson))
      setLastOrderLesson(order)
  }, [lastOrderLesson, order])

  const isLastLessonHigher = useMemo(
    () => !!order && (lastOrderLesson || -1) > order,
    [lastOrderLesson, order]
  )
  return isLastLessonHigher
}
